import script from "./DescktopCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DescktopCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./DescktopCalendar.vue?vue&type=style&index=0&id=6c0a4421&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c0a4421"]])

export default __exports__